import { createFileRoute, redirect } from '@tanstack/react-router'

import { bookingSessionSearchSchema } from '@/lib/schemas/booking-session-search.schema'

export const Route = createFileRoute('/_booking/checkout')({
  validateSearch: bookingSessionSearchSchema,
  beforeLoad: ({ search }) => {
    throw redirect({ to: '/paiement', search, replace: true })
  },
})
